import React from "react";
import { useRecordContext } from "react-admin";
import { lighten, darken } from "@mui/material";
import Typography from "@mui/material/Typography";

type ContextTagFieldProps = {
	source: string;
	label?: string;
};

type PillProps = {
	color: string;
	text: string;
};

const ContextTagField = ({
	source,
	label: _label = "",
}: ContextTagFieldProps) => {
	const record = useRecordContext();
	if (!record) return null;

	let textToDisplay: string;
	if (source === "type" && record[source] === "virtual composite") {
		textToDisplay = record.context;
	} else if (source === "type" && record[source] === "lot composite") {
		textToDisplay = record.context;
	} else if (source === "type" && record[source] === "fso2") {
		textToDisplay = "fSO\u2082";
	} else {
		textToDisplay = record[source];
	}

	let color = "#464042";
	switch (textToDisplay) {
		case "before addition":
			color = "#730519";
			break;
		case "spotcheck after add":
			color = "#105F73";
			break;
		case "lot addition":
			color = "#00A87B";
			break;
		case "addition":
			color = "#00A87B";
			break;
		case "fSO\u2082":
			color = "#464042";
			break;
		default:
			break;
	}
	return <Pill color={color} text={textToDisplay} />;
};

export const Pill = ({ color, text }: PillProps) => {
	const style = {
		marginLeft: -3,
		display: "inline-block",
		alignSelf: "flex-start",

		paddingTop: 2,
		paddingBottom: 1,
		paddingLeft: 3,
		paddingRight: 3,

		borderStyle: "solid",
		borderWidth: 1,
		borderColor: lighten(color, 0.82),
		borderRadius: 4,

		color: darken(color, 0),
		background: lighten(color, 0.93),
	};

	return text !== "" ? (
		<Typography variant="body2" style={style}>
			{text}
		</Typography>
	) : (
		<Typography variant="body2">{"\u00A0"}</Typography>
	);
};

export { ContextTagField };
